class Menu {
    ready() {

        let navigationMenu = $("nav.second-nav");

        // The redesigned header no longer renders nav.second-nav. Guard the
        // offset() read so a missing element can't throw and abort the rest of
        // the $(document).ready chain (which would skip formValidation, cookie
        // consent, etc.).
        if (navigationMenu.length) {
            let sticky = navigationMenu.offset().top;  // Using the jQuery offset() method

            $(document).on("scroll", function () {
                (window.pageYOffset > sticky) ? navigationMenu.addClass("sticky") : navigationMenu.removeClass("sticky");
            });
        }


        function toggleMenu() {
            if (window.innerWidth < 992) {
                $(".desktop-navigation").hide();
                $(".mobile-navigation").show();
            }
            if (window.innerWidth >= 991) {
                $(".desktop-navigation").show();
                $(".mobile-navigation").hide();

            }

        }
        toggleMenu();

        window.onresize = function () {
            toggleMenu();
        };

            // $('.navbar-toggler').on('click', function () {
            //
            //     if(!$('.navbar-collapse').hasClass('show')) {
            //         $('.open-nav').fadeOut();
            //         $('.close-nav').fadeIn();
            //     } else {
            //         $('.open-nav').fadeIn();
            //         $('.close-nav').fadeOut();
            //     }
            // });
    }
}

export default new Menu();